import { defineStore } from 'pinia';
import { http } from '../transport/http';
import type { INotificationsStatus, INotificationsStatusWorker } from '~/types/notifications';
import type { IHttpRequestOptions } from '~/types/transport/http';

export const useStoreNotificationsStatus = defineStore('notificationsStatus', {
  state: () => ({
    notificationStatuses: {} as INotificationsStatusWorker,
    isLoaded: false,
    requestPromise: null as Promise<any> | null,
  }),
  actions: {
    async load(params: { playerId?: string | null }) {
      if (!params.playerId) {
        return;
      }

      if (!this.requestPromise) {
        this.requestPromise = http()
          .post(null, {
            url: `/cf-api/notifications-status`,
            payload: {
              playerID: params.playerId,
              method: 'get',
            },
            force: true,
          } as IHttpRequestOptions)
          .finally(() => (this.requestPromise = null));
      }

      const response = (await this.requestPromise) as INotificationsStatusWorker;

      if (response) {
        this.notificationStatuses = response;
        this.isLoaded = true;
      }
    },
    /**
     * Method for marking notification as read by adding notification data to Strapi
     * @param ctx context object
     * @param params notification object
     */
    async markRead(params: INotificationsStatus) {
      const notificationID = `${params.type}_${params.record_id}`;
      const isReadedAlready = this.notificationStatuses[notificationID]?.readed;
      if (isReadedAlready) {
        return;
      }

      const data = await http().post(null, {
        url: `/cf-api/notifications-status`,
        payload: {
          playerID: params.player_id,
          notificationID,
          type: params.type,
          readed: true,
          method: 'put',
        },
        force: true,
        cacheble: false,
      } as IHttpRequestOptions);
      if (data) {
        this.notificationStatuses = {
          ...this.notificationStatuses,
          [notificationID]: data,
        };
      }
    },

    clearStore() {
      this.$reset();
    },
  },
});
